<ziro-top-nav></ziro-top-nav>
<div class="ziro-distribution-list-page-content">
  <div class="col-md-10 offset-md-1 top-buffer">
    <ziro-breadcrumbs></ziro-breadcrumbs>
    <div class="card bg-light">
      <div class="card-body">
        <legend class="mt-0 pb-2">
          <ziro-stacked-icon
            [stackedIcon]="ZiroStackedIcons[ziroIcons.ADD_MEMBER_TO_DISTRIBUTION_LIST]"
            parentClass="fa-stack"
          ></ziro-stacked-icon>

          {{ 'tkey;pages.distributionlist.add.pagetitle' | translate }}
        </legend>
        <!-- Confirm to add an user from search result -->
        @if (confirmAdd) {
          <div>
            <div
              [innerHTML]="
                'tkey;pages.distributionlist.add.confirm'
                  | escapeHtml
                    : {
                        memberAlias: userToAdd.alias,
                        memberDisplayName: userToAdd.displayName,
                        listAlias: distributionList.alias,
                        listDisplayName: distributionList.displayName,
                      }
              "
            ></div>
            <div [innerHTML]="'tkey;pages.distributionlist.add.confirm.continue' | escapeHtml"></div>
            <hr />
            <div class="text-end">
              <ziro-button
                [dataAutomation]="'add-member-cancel-button'"
                [label]="'tkey;pages.distributionlist.add.cancel'"
                (clicked)="goToConfirmAddPage(false)"
                [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                [buttonSize]="buttonSizes.NORMAL"
                [cssClass]="'me-1'"
                [isDisabled]="isAddingUser"
              ></ziro-button>
              <ziro-button
                [dataAutomation]="'add-member-confirm-button'"
                [label]="'tkey;pages.distributionlist.add.member'"
                (clicked)="addUserToList()"
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                [buttonSize]="buttonSizes.NORMAL"
                [cssClass]="'ms-1'"
                [isPending]="isAddingUser"
                [iconPending]="ziroIcons.SAVING"
                [icon]="ziroIcons.ADD"
              ></ziro-button>
            </div>
          </div>
        }
        <!-- Search user -->
        <div>
          <form (keyup.enter)="onEnterSubmit()" [hidden]="confirmAdd">
            <div class="input-group mb-3">
              <ziro-text [fieldId]="'search'" [borderRadOnlyLeft]="true" class="flex-fill"></ziro-text>
              <ziro-submit-button
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                [buttonSize]="buttonSizes.NORMAL"
                [icon]="ziroIcons.SEARCH"
                [dataAutomation]="'search-user'"
                [isDisabled]="isSubmitting"
                [isPending]="isSubmitting"
                [iconPending]="ziroIcons.SAVING"
                [formSubmitSubject]="_validateAndSubmitSource"
                [borderClass]="'input-text-end'"
              ></ziro-submit-button>
            </div>

            @if (columns) {
              <ziro-datatable
                [class]="'ziro-card'"
                class="add-to-distribution-list-datatable"
                [columns]="columns"
                [rowDataSource]="tableRows"
                [uniqueRowIdentifier]="'id'"
                [dataAutomation]="'add-to-distribution-list-datatable'"
              ></ziro-datatable>
            }
            <hr />
            <div class="text-end">
              <ziro-button
                [dataAutomation]="'back-to-distribution-list'"
                [label]="'tkey;pages.distributionlist.add.back'"
                (clicked)="backToDistributionList()"
                [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                [buttonSize]="buttonSizes.NORMAL"
              ></ziro-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
